import { AxiosObservable } from 'axios-observable/dist/axios-observable.interface';
import { BaseAPI } from '../base.api';
import { API_URL_AUTH } from '@/commons/config';
import axios from 'axios';

export class SolicitacaoAPI extends BaseAPI<any> {
  constructor() {
    super();
    this.apiSpgcUrl += `central-servicos`;
  }

  public createSolicitacao(body: any): AxiosObservable<any> {
    return this.axios.post(`${this.apiSpgcUrl}/solicitacao`, { ...body });
  }

  public getRegrasValidacao(): AxiosObservable<any> {
    return this.axios.get(`${this.apiSpgcUrl}/regras-validacao`);
  }

  public getSolicitacaoByCnpj(cnpj: string): AxiosObservable<any> {
    return this.axios.get(`${this.apiSpgcUrl}/solicitacao?cnpj=${cnpj}`);
  }

  public getSolicitacaoByProtocoloAndToken(token: string, protocolo: string): AxiosObservable<any> {
    return this.axios.get(`${this.apiSpgcUrl}/protocolo/${protocolo}/token/${token}`);
  }

  public signinToUploadDoc(protocolo: string, token: string): AxiosObservable<any> {
    let url = API_URL_AUTH.replace(/\/signin$/, '');
    return this.axios.post(`${url}/spgc/signin`, { protocolo, token });
  }

  public updateDocument(
    conteudoBase64: string,
    idDocument: string,
    protocolo: string
  ): Promise<any> {
    let tokenJWT = localStorage.getItem(`${protocolo}`) || '';
    const customAxios = axios.create({
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${tokenJWT}`,
        Accept: '*/*',
        protocolo: protocolo,
      },
    });
    return customAxios.patch(`${this.apiSpgcUrl}/arquivo/${idDocument}`, { conteudoBase64 });
  }

  public verificarAutorizacaoConsumidorCativo(cnpj: string): AxiosObservable<any> {
    return this.axios.get(`${this.apiSpgcUrl}/verificar-autorizacao-consumidor-cativo-livre`, {
      params: { cnpj },
    });
  }
  public reenviarToken(protocolo: number, tipoSolicitacao: string): AxiosObservable<any> {
    return this.axios.post(`${this.apiSpgcUrl}/reenviar-token`, { protocolo, tipoSolicitacao });
  }
  public checkValidAutorizacao(token: string, protocolo: string): AxiosObservable<any> {
    return this.axios.get(`${this.apiSpgcUrl}/protocolo/${protocolo}/token/${token}`, {
      params: { token, protocolo },
    });
  }
}
